import { render } from "./ExamRuleView.vue?vue&type=template&id=07b7ef0d&scoped=true"
import script from "./ExamRuleView.vue?vue&type=script&lang=js"
export * from "./ExamRuleView.vue?vue&type=script&lang=js"

import "./ExamRuleView.vue?vue&type=style&index=0&id=07b7ef0d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Emertat\\Desktop\\p\\nazerhelp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07b7ef0d"]])

export default __exports__